import { Signal } from "@preact/signals-core";
import { ofetch } from "ofetch";

interface FetchOptions extends Record<string, any> {
  searchString?: string;
  initial?: boolean;
}

export const fetchReferences = async (options?: FetchOptions, signal?: AbortSignal) => {
  const response = await ofetch<Reference[]>("/index.php", {
    query: flattenQuery({
      type: 724463537,
      tx_vdbundle_pi1: {
        controller: "Reference",
        action: "ajaxReferences",
        limit: 1000,
        ...options,
      },
    }),
    signal,
    parseResponse: JSON.parse,
  });

  return response;
};

interface FlattenedQuery {
  [key: string]: string | number | boolean;
}

function flattenQuery(obj: Record<string, any>, parentKey: string = ""): FlattenedQuery {
  let result: FlattenedQuery = {};

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let newKey = parentKey ? `${parentKey}[${key}]` : key;

      if (Array.isArray(obj[key])) {
        result[newKey] = obj[key].join(",");
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        Object.assign(result, flattenQuery(obj[key], newKey));
      } else {
        result[newKey] = obj[key];
      }
    }
  }

  return result;
}

export interface Reference {
  title: string;
  slug: string;
  previewImage?: string;
  teaser: {
    long: string;
    short: string;
  };
}
